<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col md="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{ product.code ? $route.name + " - " + product.code : "PRODUCT (NEW)"}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
            </nav>
            </b-col>
        </b-row>
        </base-header>
        <div>
            <!-- <vue-element-loading :active="loading" :is-full-screen="true" color="#fb6340"/> -->
            <loading :active="loading > 0" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6 container-padding">
            <b-row>
                <b-col md="12">
                    <div class="card-wrapper">
                        <b-card no-body>
                            <b-tabs pills card>
                                <b-tab :title="language_terms['BASIC_INFORMATION']" active>
                                     <b-card-text>
                                         <card>
                                             <div slot="header">
                                                <b-row>
                                                    <b-col md="6">
                                                        <h3 >{{language_terms['BASIC_INFORMATION']}} 
                                                            <span v-if="product.code">({{product.code}})</span>
                                                        </h3>
                                                    </b-col>
                                                    <!-- <b-col md="6" >
                                                        <base-button icon type="danger" class="float-right" @click="deleteProduct" v-if="$route.params.id != '_new'">
                                                            <span class="btn-inner--text">{{language_terms['DELETE']}}</span>
                                                        </base-button>
                                                    </b-col> -->
                                             </b-row>
                                             </div>

                                             <b-row>
                                                <b-col md="6">
                                                    <base-input :label="language_terms['PRODUCT_NAME']" v-model="product.name" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                 <b-col md="3">
                                                    <base-input :label="language_terms['PRODUCT_CODE']" v-model="product.code" :disabled="isLocked"></base-input>
                                                 </b-col>                                                 
                                                 <b-col md="3">
                                                    <base-input :label="language_terms['GTIN']" v-model="product.gtin" :disabled="isLocked"></base-input>
                                                 </b-col>                                                 
                                                <b-col md="2">
                                                    <base-input :label="language_terms['LIST_PRICE']" v-model="product.sale_list_price" :disabled="isLocked"></base-input>
                                                </b-col>                                                 
                                                <b-col md="2">
                                                    <base-input :label="language_terms['BASED_UOM']" v-model="product.base_uom" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                 <b-col md="2">
                                                    <base-input :label="language_terms['MOQ']" v-model="product.moq" type="number" :min="0" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                 <!-- <b-col md="2">
                                                    <base-input label="Switch %" v-model="product.uom_base_switch_percent" type="number" :min="0" :disabled="isLocked"></base-input>
                                                 </b-col> -->
                                                <b-col md="6">
                                                     <base-input :label="language_terms['STORAGE_CLASSIFICATIONS']" :disabled="isLocked">
                                                        <el-select v-model="product.storageclassification_id" filterable 
                                                        :placeholder="language_terms['STORAGE_CLASSIFICATIONS']" :disabled="isLocked">
                                                            <el-option v-for="option in storage_classifications"
                                                                    :key="option.storageclassification_id"
                                                                    :label="option.storageclassification_name"
                                                                    :value="option.storageclassification_id">
                                                            </el-option>
                                                        </el-select>
                                                     </base-input>
                                                 </b-col>


                                                 <b-col md="6">
                                                    <label class="form-control-label">{{language_terms['CATEGORIES']}}</label>
                                                    <multiselect
                                                        open-direction="bottom"
                                                        :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                                        :placeholder="language_terms['SEARCH_ADD_TAG']"
                                                        label="name"
                                                        track-by="id"
                                                        :options="product_categories"
                                                        text-field="name"
                                                        :multiple="true"
                                                        v-model="product.category_items"
                                                        :taggable="false"
                                                        :disabled="isLocked"
                                                        ></multiselect>
                                                 </b-col>
                                                 

                                                <b-col md="3">
                                                    <base-input :label="language_terms['BRAND']" v-model="product.brand" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                <b-col md="3">
                                                    <base-input :label="language_terms['MODEL']" v-model="product.model" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                <!-- <b-col md="12">
                                                    <base-input :label="language_terms['PRODUCT_DESP_LONG']" > 
                                                        <textarea class="form-control" rows="3" v-model="product.desp_long"></textarea>
                                                    </base-input>
                                                    <html-editor v-model="product.desp_long"></html-editor>
                                                 </b-col> -->
                                             </b-row>
                                             <b-row>
                                                <b-col md="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.is_sold" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['IS_SOLD']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                                <b-col md="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.is_purchased" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['IS_PURCHASED']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                                <b-col md="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.is_inventorized" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['IS_INVENTORIZED']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                                <b-col md="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.has_lot" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['HAS_LOT']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                                 <b-col md="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.is_trade" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['IS_TRADE_ITEM']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                             </b-row>
                                             <b-row>
                                                <b-col cols="12">
                                                    <h3>{{language_terms['OTHERS']}}</h3>
                                                </b-col>
                                                <b-col md="3">
                                                    <base-input :label="language_terms['EXPIRY_MONTHS']" v-model="product.expiry_mths" :disabled="isLocked" type="number"></base-input>
                                                 </b-col>
                                                <b-col md="3">
                                                    <base-input :label="language_terms['WARRANTY_MONTHS']" v-model="product.warranty_mths" :disabled="isLocked" type="number"></base-input>
                                                </b-col>
                                                <b-col md="3">
                                                    <base-input :label="language_terms['RESERVATION_MAX_DAYS']" v-model="product.reservation_max_days" :disabled="isLocked" type="number"></base-input>
                                                </b-col>
                                                <b-col md="3">
                                                    <base-input :label="language_terms['SALES_QUOTATION_VALIDITY_DAYS']" v-model="product.sales_quotation_validity_days" :disabled="isLocked" type="number"></base-input>
                                                </b-col>
                                             </b-row>
                                             <hr/>
                                             <b-row>
                                                 <b-col cols="12">
                                                    <h3>{{language_terms['PRODUCT_LANGUAGES']}}</h3>
                                                 </b-col>
                                                 <b-col cols="12" v-for="(item, index) of product.languages" :key="index">
                                                     <b-card>
                                                         <b-row>
                                                             <b-col cols="10">
                                                                <img :src="`/flag-icons/${item.icon}.png`" class="mr-3">
                                                                {{item.language_name}}
                                                             </b-col>
                                                             <b-col cols="2">
                                                                <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" class="float-right mr-1"><i class="fa fa-angle-down"></i></base-button>
                                                             </b-col>
                                                         </b-row>
                                                        <b-collapse v-model="item.is_collapsed" class="mt-2">
                                                            <b-row>
                                                                <b-col cols="6">
                                                                    <base-input :label="language_terms['PRODUCT_NAME']" v-model="item.name" :disabled="isLocked" type="text"></base-input>
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <base-input :label="language_terms['DESP']" v-model="item.desp" :disabled="isLocked" type="text"></base-input>
                                                                </b-col>
                                                                <b-col cols="12">
                                                                    <vue-editor v-model="item.desp_html" :editorToolbar="customToolbar" :disabled="isLocked" ></vue-editor>
                                                                </b-col>
                                                            </b-row>
                                                        </b-collapse>
                                                     </b-card>
                                                 </b-col>
                                             </b-row>

                                         </card>
                                     </b-card-text>
                                        <div class="floating-bar">
                                            <div class="floating-bar-container" align="center">
                                                <b-button-group>
                                                    <b-button class="transparent-btn"  @click="showFloatBtn" v-if="!isShowBtn">
                                                        <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                                                    </b-button>
                                                    <b-button class="transparent-btn"  @click="saveProduct" v-if="isShowBtn">
                                                        <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                                    </b-button>
                                                    <b-button class="transparent-btn"  @click="cancelProduct" v-if="isShowBtn">
                                                        <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                                                    </b-button>
                                                    <b-button class="transparent-btn" @click="deleteProduct" v-if="$route.params.id != '_new'">
                                                        <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </div>
                                </b-tab>

<b-tab :title="language_terms['UOM']" v-if="show_tabs">
  <b-card-text>
    <card>
      <h3 slot="header">{{ language_terms['UOM'] }}</h3>
      <b-row>
        <b-col md="4">
          <label class="form-control-label">{{ language_terms['PRODUCT'] }}</label>
          <productLookup
            :url="apiProductLookup"
            @selected="selectProduct($event)"
            :lookupId="uom.product_code"
            :disabled="isEditingUom"
          />
        </b-col>
        <b-col md="2">
          <base-input :label="language_terms['SKU']" v-model="uom.product_code" disabled></base-input>
        </b-col>
        <b-col md="2">
          <base-input :label="language_terms['MULTIPLIER']" v-model="uom.multiplier" :disabled="product.code == uom.product_code" type="number"></base-input>
        </b-col>
        <b-col md="2">
          <base-input label="Sale Switch %" v-model="uom.uom_base_switch_percent" type="number"></base-input>
        </b-col>
        <b-col md="2" class="mt-4">
          <base-button
            type="primary"
            class="mt-2"
            @click.native="isEditingUom ? updateProductUom() : addProductUom()"
          >
            <span class="btn-inner--text">
              {{ isEditingUom ? language_terms['UPDATE'] : language_terms['ADD'] }}
            </span>
          </base-button>
          <base-button
            v-if="isEditingUom"
            type="secondary"
            class="mt-2 ml-2"
            @click.native="cancelUomEdit()"
          >
            <span class="btn-inner--text">{{ language_terms['CANCEL'] }}</span>
          </base-button>
        </b-col>
      </b-row>
      <b-row v-if="product.product_uoms.length > 0">
        <b-col md="12">
          <b-table-simple hover>
            <b-thead head-variant="light">
              <b-th>{{ language_terms['SKU'] }}</b-th>
              <b-th>{{ language_terms['MULTIPLIER'] }}</b-th>
              <b-th>SALE SWITCH %</b-th>
              <b-th>{{ language_terms['ONHAND_QTY'] }}</b-th>
              <b-th>{{ language_terms['SALE_QTY'] }}</b-th>
              <b-th>{{ language_terms['UNIT_PRICE'] }}</b-th>
              <b-th></b-th>
            </b-thead>
            <b-tbody>
              <tr
                v-for="(item, j) in product.product_uoms"
                :key="j"
                @click="editUom(item)"
              >
                <td>{{ item.product_code }}</td>
                <td>{{ item.multiplier }}</td>
                <td>{{ item.uom_base_switch_percent }}</td>
                <td>{{ item.qty_available }}</td>
                <td>{{ item.qty_switched }}</td>
                <td>{{ item.unit_price ? item.unit_price : '-' }}</td>
                <td>
                  <base-button
                    icon
                    type="warning"
                    @click.stop="deleteUOM(item)"
                    size="sm"
                    :disabled="(item.is_default == 1)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </base-button>
                </td>
              </tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
    </card>
  </b-card-text>
</b-tab>

                                <b-tab :title="language_terms['CODES']" v-if="show_tabs">
                                    <b-card-text>
                                        <card>
                                            <h3 slot="header">{{language_terms['CODES']}}</h3>
                                            <b-row>
                                                <b-col md="3">
                                                    <base-input :label="language_terms['TYPE']">
                                                        <el-select v-model="product_code.type" filterable >
                                                        <el-option v-for="option in code_types"
                                                                    :key="option.code"
                                                                    :label="option.name"
                                                                    :value="option.code">
                                                        </el-option>
                                                        </el-select>
                                                    </base-input>
                                                </b-col>
                                                <b-col md="4">
                                                    <base-input :label="language_terms['CODE']" v-model="product_code.code"></base-input>
                                                 </b-col>
                                                <b-col md="3">
                                                    <base-input :label="language_terms['TAG']" v-model="product_code.tag"></base-input>
                                                 </b-col>
                                                <b-col md="2" class='mt-4'>
                                                    <base-button  type="primary" class='mt-2' @click.native="addProductCode">
                                                        <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                                                    </base-button>
                                                 </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col md="12" v-for="(code, index) in product.product_codes" :key="index">
                                                    <b-card>
                                                        <b-row>
                                                            <b-col cols="4">
                                                                <barcode :value="code.code" :tag="'svg'" :options="options_upc" v-if="code.type == 'barcode_upc'" ></barcode>
                                                                <barcode :value="code.code" :tag="'svg'" :options="options_code_128" v-if="code.type == 'barcode_code128'" ></barcode>
                                                                <qr-code :text="code.code" v-if="code.type == 'qrcode'" :size="size"></qr-code>
                                                            </b-col>
                                                            <b-col cols="3">
                                                                <base-input :label="language_terms['VALUE']" v-model="code.code" disabled></base-input>
                                                            </b-col>
                                                              <b-col cols="3">
                                                                <base-input :label="language_terms['TAG']" v-model="code.tag" disabled></base-input>
                                                            </b-col>
                                                            <b-col cols="2" class='mt-4'>
                                                                <base-button icon type="warning" @click="deleteCode(code)" class='mt-2 '>
                                                                    <i class="fa fa-trash" aria-hidden="true" ></i>
                                                                </base-button>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card>
                                                </b-col>
                                            </b-row>
                                        </card>
                                    </b-card-text>
                                </b-tab>
                                 <b-tab :title="language_terms['MEDIAS']" v-if="show_tabs">
                                    <b-row>
                                        <b-col cols="12">
                                            <dropzone id="myVueDropzone" 
                                                ref="myVueDropzone" 
                                                class="mb-2" 
                                                :options="dropzoneOptions" 
                                                v-on:vdropzone-sending="sendingImage" 
                                                v-on:vdropzone-removed-file ="removeImage" > 
                                                <input type="hidden" name="token" value="xxx" >
                                            </dropzone>
                                        </b-col>
                                        
                                    </b-row>
                                    <!--Product Medias Display-->
                                    <b-row>
                                        <b-col xl="3" md="6" v-for="option in product.product_medias" :key= option.id>
                                            <!-- <b-card-group> -->
                                                <b-card no-body class="overflow-hidden mb-4">
                                                    <b-row no-gutters>
                                                        <b-col md="12">
                                                            <b-card-body>
                                                                <b-card-text><small>
                                                                {{option.file_name}}</small>
                                                                </b-card-text>
                                                                <base-button  size="sm" type="warning" @click="deleteMedia(option)">
                                                                    <i class="fa fa-times"></i>
                                                                </base-button>                                                                
                                                            </b-card-body>
                                                        </b-col>
                                                        <b-col md="12">
                                                            <b-img :src=option.url thumbnail fluid alt="image"></b-img>
                                                            <!-- <b-card-img :src="option.url" alt="Image" class="rounded-0"></b-card-img> -->
                                                        </b-col>
                                                    </b-row>
                                                </b-card>
                                            <!-- </b-card-group> -->
                                        </b-col>

                                        <!-- <b-col cols="4" v-for= "option in product.product_medias" :key = option.id>
                                            <card class="container">
                                                <div  style="height:340px;width:340px" class="image">
                                                    <img :src="option.url" class="img-fluid rounded imgColor" v-if="(option.file_extension != 'pdf')">
                                                    <a :href="option.url" target="_blank" v-else><i class="fa fa-file" aria-hidden="true"></i> &nbsp; {{option.file_name}}</a>
                                                </div>
                                                <div class="middle">
                                                    <span class="hoverDelete">{{option.file_name}}</span><br/>
                                                    <base-button  size="sm" type="warning" @click="deleteMedia(option)">
                                                        <i class="fa fa-times"></i>
                                                    </base-button>
                                                </div>
                                            </card>
                                        </b-col> -->
                                    </b-row>
                                    <!--Product Medias Display End-->
                                </b-tab>
                                <b-tab :title="language_terms['RFID']" v-if="show_tabs">
                                    <b-card-text>
                                        <card>
                                        <h3 slot="header">RFID Tags</h3>
                                        <b-row>
                                            <b-col md="4">
                                            <base-input label="RFID Tag" v-model="rfid_tag.code"></base-input>
                                            </b-col>
                                            <b-col md="2">
                                            <base-input
                                                label="Serialized Count"
                                                type="number"
                                                min="1"
                                                v-model="rfid_tag.serialized_count"
                                            ></base-input>
                                            </b-col>
                                            <b-col md="4">
                                            <base-input label="Label" v-model="rfid_tag.tag"></base-input>
                                            </b-col>
                                            <b-col md="2" class="mt-4">
                                            <base-button type="primary" class="mt-2" @click="addRfidTag">
                                                <span class="btn-inner--text">{{ language_terms['ADD'] }}</span>
                                            </base-button>
                                            </b-col>
                                        </b-row>

                                        <b-row v-if="product.rfid_tags && product.rfid_tags.length > 0">
                                            <b-col md="12">
                                            <b-table-simple hover>
                                                <b-thead head-variant="light">
                                                <b-th>RFID Tag</b-th>
                                                <b-th>Label</b-th>
                                                <b-th>Status</b-th>
                                                <b-th></b-th>
                                                </b-thead>
                                                <b-tbody>
                                                <tr v-for="(item, index) in product.rfid_tags" :key="index">
                                                    <td>{{ item.code }}</td>
                                                    <td>{{ item.tag }}</td>
                                                    <td>{{ item.status }}</td>
                                                    <td>
                                                        <base-button icon type="success" size="sm" @click="printRfidTag(item)">
                                                            <i class="fa fa-print"></i>
                                                        </base-button>

                                                        <base-button icon type="warning" size="sm" @click="deleteRfidTag(item)">
                                                            <i class="fa fa-trash"></i>
                                                        </base-button>
                                                    </td>
                                                </tr>
                                                </b-tbody>
                                            </b-table-simple>
                                            </b-col>
                                        </b-row>
                                        </card>
                                    </b-card-text>
                                </b-tab>                                
                                <b-tab title="URL Crawlers" v-if="0">
                                   <b-card-text>
                                        <card>
                                            <h3 slot="header">URL Crawlers</h3>
                                            <b-row>
                                                <b-col cols="9">
                                                    <base-input :label="language_terms['URL']" v-model="uom.code"></base-input>
                                                </b-col>
                                                <b-col cols="2">
                                                    <base-input :label="language_terms['REFERENCE']" v-model="uom.multiplier"></base-input>
                                                </b-col>
                                                <b-col md="1" class='mt-4'>
                                                    <base-button  type="primary" class='mt-2' @click.native="addProductUom" disabled>
                                                        <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                                                    </base-button>
                                                 </b-col>
                                            </b-row>
                                            <b-row v-if="product.crawlers.length > 0">
                                                <b-col md="12">
                                                    <b-table-simple hover>
                                                        <b-thead head-variant="light">
                                                            <b-th>{{language_terms['REFERENCE']}}</b-th>
                                                            <b-th>{{language_terms['URL']}}</b-th>
                                                            <b-th></b-th>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <tr v-for="(item, j) in product.crawlers" :key="j">
                                                                <td>{{item.reference1}}</td>
                                                                <td>{{item.url.substr(1,150)}}...</td>
                                                                <td>
                                                                    <base-button icon type="warning" @click="deleteUOM(item)" size="sm" disabled>
                                                                        <i class="fa fa-trash" aria-hidden="true" ></i>
                                                                    </base-button>
                                                                </td>
                                                            </tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </b-col>
                                            </b-row>
                                        </card>
                                   </b-card-text>
                                </b-tab>


                            </b-tabs>
                        </b-card>
                        <b-row>
                            <b-col md="12">
                                <!-- <base-button icon type="primary"
                                    @click="saveProduct">
                                    <span class="btn-inner--text">{{language_terms['SAVE']}}</span>
                                </base-button> -->
                                <!-- <base-button icon type="danger"
                                    @click="deleteProduct">
                                    <span class="btn-inner--text">{{language_terms['DELETE']}}</span>
                                </base-button> -->
                                <!-- <base-button icon type="warning" @click="cancelProduct">
                                    <span class="btn-inner--text">{{language_terms['CANCEL']}}</span>
                                </base-button> -->
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Vue from 'vue';
import { mapState } from "vuex";
import { Select, Option } from 'element-ui'
import HtmlEditor from '@/components/Inputs/HtmlEditor'
import VueBarcode from 'vue-barcode'
import VueQRCodeComponent from 'vue-qrcode-component'
import BaseButton from '../../components/BaseButton.vue';

import {apiBaseUrl, apiRoutes} from "../../apiRoutes"
import { authHeader } from '../../global';
import Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'

import productLookup from "@/components/Autocomplete.vue";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

import { VueEditor } from "vue2-editor";

export default {
  name:'Product-Details',
  data(){
      return{
        rfid_tag: {
        code: "",
        tag: "",
        serialized_count: 1,
        },
        isEditingUom: false,  // flag to indicate update mode for UOM
        selectedProduct:{code:null},
        selected_group_index:-1,
        show_add_group:false,
        customToolbar: [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ["bold", "italic", "underline", "strike"],
            [
                { align: "" },
                { align: "center" },
                { align: "right" },
                { align: "justify" }
            ],
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            ["image", "blockquote", "link", "clean"]
        ],
        is_default_options:[
            {code:1, label :"YES"},
            {code:0, label :"NO"}
        ],
        apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
        dropzoneOptions: 
        {
            maxFiles: 1,
            url: "https://httpbin.org/post",
            thumbnailWidth: 200,
            addRemoveLinks: false,
            maxFilesize: 20,
                headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+ localStorage.access_token
                }
        },
        isLocked:true,
        isShowBtn:false,
        loading: 0,
        size:150,
        show_tabs:true,
        uom:{
            code:"",
            product_code:null,
            multiplier:null,
            unit_price:null,
            uom_base_switch_percent:null,
        },
        product_code:{
            code:"",
            type:"barcode_code128",
            tag:""
        },
        code_types:[
            {code:'barcode_upc', name:'BARCODE_UPC'},
            {code:'barcode_code128', name:'BARCODE_CODE_128'},
            {code:'qrcode', name:'QRCODE'}
        ],
        product:{
            languages:[],
            code:"",
            name:"",
            has_lot:0,
            is_trade:0,
            has_expiry:0,
            has_warranty:0,
            is_trade:0,
            warranty_mths:null,
            expiry_mths:null,
            reservation_max_days:null,
            is_sold:1,
            is_purchase:1,
            is_inventorized:1,
            base_uom:"",
            desp:"",
            desp_long:"",
            brand:"",
            model:"",
            sale_list_price:null,
            moq:"",
            is_active:1,
            sales_quotation_validity_days:null,
            category_items:[],
            product_codes:[],
            product_medias:[],
            product_uoms:[],
            currency_code:"",
            uom_base_switch_percent:null,
            
        },
        options_code_128: {
            format: "CODE128",
            lineColor: '#ff7069',
            fontSize: 32,
            font: 'Courier',
            width: 3,
            height: 30,
            marginBottom: 60,
            background: '#ccffff'
        },
        options_upc: {
            format: "upc",
            lineColor: '#ff7069',
            fontSize: 32,
            font: 'Courier',
            width: 3,
            height: 30,
            marginBottom: 60,
            background: '#ccffff'
        },
      }
  },
  components:
  {
    VueEditor,
    productLookup,
    Loading,
    Dropzone,
    // VueElementLoading,
    HtmlEditor,
    [Select.name]: Select,
    [Option.name]: Option,
    'barcode':VueBarcode,
    'qr-code':VueQRCodeComponent,
    BaseButton
  },
  computed:{
      ...mapState({
        default_sq_validity_days: state => state.sales.default_sq_validity_days,
        storage_classifications: state => state.storageclassifications.storage_classifications,
        product_filter: state =>  state.products.filter,
        product_is_created: state => state.products.is_created,
        product_is_updated: state => state.products.is_updated,
        product_is_deleted: state => state.products.is_deleted,
        uom_list:state => state.products.uom_list, 
        currencies: state => state.currencies.currencies,
        taxes: state => state.taxes.taxes,
        countries: state => state.countries.countries,
        product_data: state => state.products.product_data,
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
        product_categories: state => state.products.product_categories,
        product_media_is_updated: state => state.productMedias.is_updated,
        product_media_is_deleted: state => state.productMedias.is_deleted,
        active_languages:state => state.languages.active_languages,
        default_uom:state => state.products.default_uom

      }),
  },
  async mounted()
  {
      this.loading++
      await this.fetchCurrencies()
      await this.fetchCategories()
      await this.$store.dispatch('storageclassifications/fetchAll', {})
      await this.$store.dispatch("languages/fetchActiveLanguages", {})
      await this.$store.dispatch("products/getDefaultUOM", {})

      
      if(this.$route.params.id == '_new')
      {
          this.show_tabs = false
          this.isLocked = false
          this.isShowBtn = true
          this.product.languages = this.active_languages
          this.product.base_uom = this.default_uom
      }
      else
      {
        await this.retrieveProduct(this.$route.params.id)
        this.product = this.product_data

        if(this.product.languages == null || this.product.languages.length == 0)
        {
            this.product.languages = this.active_languages
        }
        else
        {
            this.product.languages.forEach(function(element) {
                element.is_collapsed =  false
            });
        }

        this.show_tabs = true
      }
    // Language term chages for code 
    for(let i = 0; i< this.code_types.length; i++)
    {
        this.code_types[i].name = this.language_terms[this.code_types[i].name]
    }

    this.loading--
  },
  watch:{
        language_terms: {
            handler(val){

            },
            deep: true
        }
  },
  methods:
  {
    async addRfidTag() {
        if (!this.rfid_tag.code) return;

        this.rfid_tag.product_id = this.product.id;
        this.rfid_tag.type = "rfid_tag";

        this.loading++;

        try {
            await axios.post(apiBaseUrl + "products/create-identifier", this.rfid_tag, authHeader());
            await this.retrieveProduct(this.product.code);
            this.product = this.product_data;

            this.rfid_tag = { code: "", tag: "", serialized_count: 1 };
        } catch (err) {
            console.error("Error adding RFID tags:", err);
            this.$notify({
                group: "notify",
                type: "error",
                text: "Failed to create one or more RFID tags."
        });
        }

        this.loading--;
    },

    async printRfidTag(item) {
        if (!item.id) return;
        console.log(item)

        let confirmed = await this.$confirm(
            "Print RFID Tag?",
            this.language_terms["CONFIRMATION"],
            {
            confirmButtonText: this.language_terms["YES"],
            cancelButtonText: this.language_terms["CANCEL"],
            type: "warning"
            }
        ).catch(() => false);

        if (confirmed === "confirm") {
            this.loading++;
            await axios.post(apiBaseUrl + "products/print-identifier", item, authHeader());
            item.status = 'PRINTED'
            // await this.retrieveProduct(this.product.code);
            // this.product = this.product_data;
            this.loading--;
        }
    },    
    async deleteRfidTag(item) {
        if (!item.id) return;

        let confirmed = await this.$confirm(
            "Unassociate RFID Tag?",
            this.language_terms["CONFIRMATION"],
            {
            confirmButtonText: this.language_terms["YES"],
            cancelButtonText: this.language_terms["CANCEL"],
            type: "warning"
            }
        ).catch(() => false);

        if (confirmed === "confirm") {
            this.loading++;
            await this.$store.dispatch("productCodes/delete", item);
            await this.retrieveProduct(this.product.code);
            this.product = this.product_data;
            this.loading--;
        }
    },    
    editUom(item) {
      // Make a shallow copy so changes don't affect the table until saved.
      this.uom = Object.assign({}, item);
      this.isEditingUom = true;
      // Optionally, update selectedProduct if needed:
      this.selectedProduct = { code: item.product_code, id: item.product_id };
    },

    // Cancels update mode and resets the form.
    cancelUomEdit() {
      this.uom = {
        code: "",
        product_code: null,
        multiplier: null,
        unit_price: null,
        uom_base_switch_percent: null,
      };
      this.isEditingUom = false;
    },    
    async updateProductUom() {
        // alert(this.uom.id)
        console.log(this.uom)
    //   if (!this.uom.id) return;
      this.loading++;
      try {
        const url = "productUoms/update"; // Adjust the endpoint as needed.
        await axios.post(apiBaseUrl + url, this.uom, authHeader());
        // Refresh the product data (and UOM list) after successful update.
        await this.retrieveProduct(this.product.code);
        this.product = this.product_data
        this.cancelUomEdit();
      } catch (error) {
        console.error("Error updating UOM:", error);
        // Optionally show a notification to the user here.
      } finally {
        this.loading--;
      }
    },    
    handleCollaspe(index, row)
    {
        if(row.is_collapsed)
        {
           row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }

        this.$set(this.product.languages, index , row) 
    },
    async deleteMedia(option)
    {
      if (option.id) 
      {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], 'Delete Product Media File', {    
            confirmButtonText: this.language_terms['YES'],
            cancelButtonText: this.language_terms['NO'],
            type: 'warning'
        }).catch(() => 
        {
          //this.$message.info(this.language_terms['ACTION_CANCEL'])
        })
        if (response === 'confirm') 
        {
            this.loading++
            await this.$store.dispatch("productMedias/delete", {id:option.id})
            if(this.product_media_is_deleted)
            {
                await this.retrieveProduct(this.product.code)
                this.product = this.product_data
            }
            this.loading--
        }
      }
    },
    async selectProduct(obj)
    {
        if(obj)
        {
            this.selectedProduct = obj
            this.uom.product_code = this.selectedProduct.code
        }
    },
    hasDefaultCount(items)
    {
        let count = 0;

        for(let x = 0; x < items.length; x++)
        {
            if(items[x].is_default == '1')
            {
                count++;
            }
        }

        return count
    },
    async sendingImage (file, xhr, formData) {
        let product_id = this.product.id
        await axios.post(apiRoutes['PRODUCT_MEDIA_UPLOAD'], formData, authHeader()).then (res =>{
            if (res.data.code == 1)
            {
                // console.log(res.data.data)
                let upload_id = res.data.data.upload_id
                let payload = {upload_id:upload_id, product_id}

                this.$store.dispatch("productMedias/update", payload)

                //console.log("BB")
                    // Push image to array
                let media = {
                        id:upload_id,
                        product_id:product_id,
                        url:res.data.data.url,
                        file_alias:res.data.data.file_alias,
                        file_name:res.data.data.file_name,
                        file_extension:res.data.data.file_extension
                    }
                    this.product.product_medias.push(media);

                this.$refs.myVueDropzone.removeFile(file)


            }
            else 
            {
                this.alertMessage = res.data.msg
                this.alertModal = true
            }
        })
        .catch(error => alert("Error: " + error))
    },
    removeImage(file)
    { 
        //console.log(file) 
    },
    showFloatBtn(){
        this.isShowBtn = true
        this.isLocked = false


    },
     async deleteUOM(item)
    {
        if(item.product_id)
        {
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
            confirmButtonText: this.language_terms['YES'],
            cancelButtonText: this.language_terms['CANCEL'],
            type: 'warning'
            }).catch(() => {
            this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') 
            {
                this.loading++
                let url = "productUoms/delete"
                let payload = item
                await axios.post(apiBaseUrl + url, payload, authHeader()).then (res =>{
                if (res.data.code == 1)
                {

                }
                else 
                {
                    this.alertMessage = res.data.msg
                    this.alertModal = true
                }
                })
                .catch(error => alert("Error: " + error))

                await this.retrieveProduct(this.product.code)
                this.product = this.product_data
                this.loading--
            }
        }
    },
      async deleteCode(code){
        if(code.id)
        {
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
            confirmButtonText: this.language_terms['YES'],
            cancelButtonText: this.language_terms['CANCEL'],
            type: 'warning'
            }).catch(() => {
            this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') {
                this.loading++
                await this.$store.dispatch("productCodes/delete", code)
                await this.retrieveProduct(this.product.code)
                this.product = this.product_data
                this.loading--
            }
            
        }
           
      },
    async addProductUom()
    {
        this.loading++

        if(this.uom.product_code && this.uom.multiplier)
        {
            this.uom.product_id = this.selectedProduct.id
            this.uom.base_product_id = this.product.id
            let payload = this.uom
            let url = "productUoms/create"

            await axios.post(apiBaseUrl + url, payload, authHeader()).then (res =>{
            if (res.data.code == 1)
            {

            }
            else 
            {
                this.alertMessage = res.data.msg
                this.alertModal = true
            }
            })
            .catch(error => alert("Error: " + error))
                            
            await this.retrieveProduct(this.product.code)
            this.product = this.product_data

            this.uom = {code:"", product_code:null, multiplier:null, unit_price:null}
            this.loading--;
        }
    },
    async addProductCode()
    {
        if(this.product_code.type && this.product_code.code)
        {
            // Create Product Code
            this.product_code.product_id = this.product.id
            //console.log(this.product_code)
            await this.$store.dispatch("productCodes/create", this.product_code)
           
            await this.retrieveProduct(this.product.code)
            this.product = this.product_data

            this.product_code = {code:"",type:"barcode_code128",tag:""}

        }
        else
        {
            Vue.notify({
              group: "notify",
              type: "error",
              text: this.language_terms['ERROR_MSG_ADD_PRODUCT_CODE'],
              max: 5,
              duration: 5000,
              speed: 300,
            });
        }
    },
    async retrieveProduct(code)
    {
        this.loading++
        await this.$store.dispatch("products/fetch", {
          code:code
        });
        this.loading--
        //this.product = this.product_data
    },
    fetchCategories(){
        this.loading++
        this.$store.dispatch("products/fetchAllCategories", {})
        this.loading--
    },
    fetchCurrencies(){
        this.loading++
        this.$store.dispatch("currencies/fetchAll", {});
        this.loading--
    },
    async searchProducts()
    {
        this.loading++
        let filter = {keyword:"",active_only:"1"}
        if(this.product_filter)
        {
            filter = this.product_filter
        }
        await this.$store.dispatch('products/quickSearch', filter)

        this.loading--
    },
    async saveProduct()
    {
      this.loading++
      if(this.$route.params.id == '_new')
      {
        await this.$store.dispatch("products/create", this.product);
        if(this.product_is_created)
        {
            await this.searchProducts()
            this.$router.push("/products/master")
        }
      }
      else
      {
        await this.$store.dispatch("products/update", this.product);
        if(this.product_is_updated)
        {
            await this.searchProducts()
            this.$router.push("/products/master")
        }
      }
      this.loading--
    },
    async deleteProduct(){
       // alert("delete")
        await this.$store.dispatch("products/delete", {id:this.product.id});
        if(this.product_is_deleted)
        {
            await this.searchProducts()
            this.$router.push("/products/master")
        }
     

    },
    cancelProduct(){
            if(this.$route.params.id == '_new')
            {
                this.$router.push("/users/master")
            }
            else
            {
                location.reload();
            }    }
  }
}
</script>
<style lang="scss">
.container {
  position: relative;
}

.image {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: .5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.container:hover .image {
  opacity: 0.3;
}
.container:hover .middle {
  opacity: 1;
}


</style>